<template>
  <div class="mainBody" id="index">
    <allTop></allTop>
    <transition name="fadeLeft">
      <router-view></router-view>
    </transition>
    <div style="text-align: center;padding: 10px 0;position: fixed;bottom: 0;width: 100%;z-index: 10;background-color: #F2F2F2;color: #999">
     <div style="width: 1300px;margin: auto;display: flex;justify-content: space-between;">
       <div>
         <!--        <span class="m_l_10 c_p m_r_5">关于百钢</span>-->
         <span @click="showADjust" v-if="isRegister" class="m_r_5 c_p">意见反馈</span>
         <span @click="$router.push('help')" class="m_r_5 c_p">帮助中心</span>
       </div>
       <div class="font12">
         <span class="m_r_5">版权所有：百钢</span>
         <a href="https://beian.miit.gov.cn" style="color: #999" target="_blank" class="m_b_10 m_r_10 m_t_10">Copyright © {{returnBeiAn()}}</a>
       </div>
     </div>
    </div>
    <model
    v-if="showModel" :onButton="'1'"
    :title="'意见反馈'"
    :minWidth="'500px'"
    v-on:on-cancel="showModel = false;complainData.title = '';complainData.content = '';" v-on:on-confirm="confirmAd()">
      <div class="p_d4B">
        <div class="p_r">
          <span class="m_r_5 colorRed required">为了更好的体验，请您提出宝贵的意见和建议。</span>
          <input placeholder="请输入标题" class="allInput2" v-model="complainData.title" style="border: 1px solid #eee;width: calc(100% - 10px);margin: 10px 0" type="text">
          <textarea v-model="complainData.content" @input="checkInputLength" placeholder="请输入意见内容" type="text" class="allTextarea" style="width: calc(100% - 10px);margin-left: 0;height: 150px;border: 1px solid #eee"></textarea>
          <span class="colorGray p_a" style="bottom: 10px;right: 10px">{{inputLength}}/200</span>
        </div>
      </div>
    </model>
  </div>
</template>
<script>
export default {
  name: 'index',
  data () {
    return {
      complainData: {
        content: '',
        mobile: '',
        name: '',
        reply: '',
        title: ''
      },
      showModel: false,
      inputLength: 0,
      description: '',
      isRegister: window.localStorage.getItem('memberId'),
      MemberInfo: JSON.parse(window.localStorage.getItem('MemberInfo') || '{}')
    }
  },
  destroyed () {
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    // this.returnBeiAn()
  },
  methods: {
    returnBeiAn () {
      if (window.location.host === 'www.baigang.com') {
        return '沪ICP备2020026583号-2'
      } else {
        return '沪ICP备2020026583号-1'
      }
    },
    checkInputLength () {
      let sum = 0
      for (let i = 0; i < this.complainData.content.length; i++) {
        let c = this.complainData.content.charCodeAt(i)
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
          sum++
        } else {
          sum += 2
        }
      }
      if (sum > 200) {
        this.complainData.content = this.complainData.content.substring(0, 200)
        sum = 200
      }
      this.inputLength = sum
    },
    showADjust () {
      this.showModel = true
      this.inputLength = 0
      this.description = ''
    },
    confirmAd () {
      this.complainData.name = this.MemberInfo.name
      this.complainData.mobile = this.MemberInfo.mobile
      this.$axiox.post('/baigang/shop/complaint/addComplain', this.complainData).then(p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '提交成功，感谢您的支持！',
          stayTime: 5
        })
        this.showModel = false
      })
    }
  }
}
</script>

<style scoped>
  @keyframes wordsLoop {
    0% {
      transform: translateX(200px);
      -webkit-transform: translateX(200px);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }
  @-webkit-keyframes wordsLoop {
    0% {
      transform: translateX(200px);
      -webkit-transform: translateX(200px);
    }
    100% {
      transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/myIndex/index.vue